import { Slide } from '@mui/material';
import React from 'react';
import * as S from './loading-line.styles';

interface ILoadingLineProps {
    timeout: number;
    className?: string;
}

export const LoadingLine = React.memo(
    (props: ILoadingLineProps): React.ReactElement => {
        const { timeout } = props;
        return (
            <Slide in={true} direction="right" timeout={timeout}>
                <S.LoadingLine />
            </Slide>
        );
    },
);
